<template>
  <div class="container-box" :class="fontSize">
    <div
      class="card"
      :class="{ 'card-active': active === index, 'card-gray': item.overall && active !== index }"
      v-for="(item, index) in dataList"
      :key="index"
      @click.stop="changeActive(index)"
    >
      <div class="num-tag">
        <span>{{ index + 1 }}/{{ dataList.length }}</span>
        <img class="top" :src="imageMap.subtract_gray" alt="" />
        <img v-if="active === index" class="top" :src="imageMap.subtract" alt="" />
        <img class="bottom" :src="imageMap.subtract_gray" alt="" />
        <img v-if="active === index" class="bottom" :src="imageMap.subtract" alt="" />
      </div>

      <div class="card_content" v-if="(active === index || item.overall || item.overall == 0) || listenStore.listenPrepare">
        <!--   翻译图标    -->
        <img
          v-if="item.showTranslate"
          class="icon-translate"
          :src="imageMap.icon_translate_active"
          alt=""
          @click="item.showTranslate = false"
        />
        <img
          v-else
          class="icon-translate"
          :src="imageMap.icon_translate"
          alt=""
          @click="item.showTranslate = true"
        />

        <!--   刮刮乐遮罩图片   -->
        <div v-if="!item.showSentence && !listenStore.listenPrepare" class="mask-box"></div>
        <div v-show="item.showSentence || listenStore.listenPrepare" class="sentence">{{ item.sentenceText }}</div>

        <!--   翻译  -->
        <p v-if="item.showTranslate" class="translate-text">翻译：{{ item.sentenceTranslation }}</p>

        <div style="margin-top: 0.9rem" v-if="active === index && !listenStore.listenPrepare">
          <Record
            ref="recordRef"
            class="record-box"
            :ref-text="item.sentenceText"
            :overall="item.overall"
            :aduio-src="item.sentenceAudio"
            :my-audio-url="item.myAudioUrl"
            @finishScore="handleFinishScore"
          />
        </div>
      </div>

      <!--  骨骼线    -->
      <div class="thumbnail-box" v-else>
        <ion-skeleton-text
          class="thumbnail-item thumbnail-item_1"
          :animated="false"
        ></ion-skeleton-text>
        <ion-skeleton-text
          class="thumbnail-item thumbnail-item_2"
          :animated="false"
        ></ion-skeleton-text>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, ref, watch, onUnmounted } from "vue";
import Record from "./components/Record.vue";
import { useListenConfigStore } from "@/hooks/useListenConfigStore";
import { imageConfig } from "@/views/listening/components/ThemeTag/imageConfig";
import store from "@/js/store";

// 常量定义集中管理
const CONSTANTS = {
  PASS_SCORE: 70,
  THRESHOLD: 90,
  OSS_URL: `${store.getOEMBASE() || ""}grammar_content/`
};

// 状态管理
const listenStore = useListenConfigStore();
const imageMap = computed(() => imageConfig[theme.value]);
const theme = computed(() => listenStore.theme);
const fontSize = computed(() => listenStore.fontSize);

// 组件通信
const props = defineProps(["linkContent"]);
const emit = defineEmits(["recordFinish"]);

// 响应式数据
const active = ref(0);
const dataList = ref([]);
const recordRef = ref();

// 监听props变化
watch(
  () => props.linkContent,
  (newVal) => {
    if (!newVal) return;

    dataList.value = newVal.map(item => ({
      ...item,
      showTranslate: listenStore.showTranslate,
      // 处理已有答案的情况
      ...(item.studentAnswer && {
        ...parseStudentAnswer(item.studentAnswer)
      })
    }));

    if (listenStore.listenPrepare) return;

    nextTick(() => {
      initSentenceHighlight();
      initMaskImg();
    });
  }
);

// 监听翻译显示状态变化
watch(
  () => listenStore.showTranslate,
  (newVal) => {
    dataList.value.forEach(item => {
      item.showTranslate = newVal;
    });
  }
);

// 解析学生答案
const parseStudentAnswer = (studentAnswer) => {
  const scoreResult = JSON.parse(studentAnswer.scoreResult);
  return {
    overall: scoreResult.result.overall,
    showSentence: scoreResult.result.overall >= CONSTANTS.PASS_SCORE,
    scoreResult: scoreResult.result,
    myAudioUrl: studentAnswer.audioFile
  };
};

// 初始化句子高亮
const initSentenceHighlight = () => {
  const cardArr = document.querySelectorAll(".card");
  cardArr.forEach((item, index) => {
    const dataItem = dataList.value[index];
    if (dataItem.overall != null) {
      const sentenceEls = item.querySelectorAll(".sentence");
      sentenceEls.forEach(el => {
        el.innerHTML = splitWord(dataItem.sentenceText, dataItem.scoreResult?.details || []);
      });
    }
  });
};

// 刮刮乐效果相关
let startX = 0;
let startY = 0;

const initMaskImg = () => {
  // 先移除旧事件监听，避免重复绑定
  const oldImages = document.querySelectorAll(".mask-box");
  oldImages.forEach(imgDom => {
    removeMaskEvents(imgDom);
  });

  // 绑定新事件
  const images = document.querySelectorAll(".mask-box");
  images.forEach(imgDom => {
    addMaskEvents(imgDom);
  });
};

// 添加遮罩事件
const addMaskEvents = (imgDom) => {
  imgDom.addEventListener("touchstart", handleStart);
  imgDom.addEventListener("touchmove", handleMove);
  imgDom.addEventListener("touchend", handleEnd);
  imgDom.addEventListener("mousedown", handleStart);
  imgDom.addEventListener("mousemove", handleMove);
  imgDom.addEventListener("mouseup", handleEnd);
  imgDom.addEventListener("mouseleave", handleEnd);
};

// 移除遮罩事件
const removeMaskEvents = (imgDom) => {
  imgDom.removeEventListener("touchstart", handleStart);
  imgDom.removeEventListener("touchmove", handleMove);
  imgDom.removeEventListener("touchend", handleEnd);
  imgDom.removeEventListener("mousedown", handleStart);
  imgDom.removeEventListener("mousemove", handleMove);
  imgDom.removeEventListener("mouseup", handleEnd);
  imgDom.removeEventListener("mouseleave", handleEnd);
};

const handleStart = (e) => {
  const point = e.type.includes("touch") ? e.touches[0] : e;
  startX = point.clientX;
  startY = point.clientY;
};

const handleMove = (e) => {
  e.preventDefault();
};

const handleEnd = (e) => {
  if ((e.type === 'touchend' && e.toElement) || startX === 0) return;

  const point = e.type.includes("touch") ? e.changedTouches[0] : e;
  const distanceX = point.clientX - startX;
  const distanceY = point.clientY - startY;
  const totalDistance = Math.sqrt(distanceX **2 + distanceY** 2);

  if (totalDistance >= CONSTANTS.THRESHOLD) {
    dataList.value[active.value].showSentence = true;
    startX = 0
  }
};

// 切换激活项
const changeActive = async (val) => {
  active.value = val;

  if (listenStore.listenPrepare) return;

  nextTick(() => {
    initMaskImg();
    // 安全访问ref
    if (recordRef.value?.[0]) {
      recordRef.value[0].resetMyAudio();
    }
  });
};

// 处理评分完成
const handleFinishScore = (score) => {
  dataList.value[active.value].scoreResult = score.result;
  dataList.value[active.value].overall = score.result.overall;
  dataList.value[active.value].myAudioUrl = score.audioUrl;

  if (score.result.overall >= CONSTANTS.PASS_SCORE) {
    dataList.value[active.value].showSentence = true;
  }

  emit("recordFinish", {
    titleNumber: dataList.value[active.value].sentenceIndex,
    score: score,
    currentItem: dataList.value[active.value],
  });

  nextTick(() => {
    const cardActive = document.querySelector(".card-active");
    if (cardActive) {
      const sentence = cardActive.querySelector(".sentence");
      if (sentence) {
        sentence.innerHTML = splitWord(sentence.innerText, score.result.details);
      }
    }

    // 达到通过分数，自动跳转下一题
    if (score.result.overall >= CONSTANTS.PASS_SCORE && active.value + 1 < dataList.value.length) {
      active.value++;
      changeActive(active.value);
    }
  });
};

// 拆分单词并添加颜色
const splitWord = (sentence, details = []) => {
  if (!sentence) return '';

  return sentence.split(" ").map((word, index) => {
    const score = details?.[index]?.score;
    const pureWord = word.replace(/[.!?。！？,]\s*$/, '');
    const punctuation = word.replace(pureWord, '');

    return `${setColorLabel(pureWord, score)}${punctuation} `;
  }).join('');
};

const setColorLabel = (word, score) => {
  if (score >= 80) {
    return `<span class="highlight-green">${word}</span>`;
  } else if (score >= 60) {
    return `<span class="highlight-yellow">${word}</span>`;
  } else {
    return `<span class="highlight-red">${word}</span>`;
  }
};

// 组件暴露
defineExpose({
  active,
  dataList,
});

// 挂载时初始化
onMounted(() => {
  initMaskImg();
});

// 清理事件监听
onUnmounted(() => {
  const images = document.querySelectorAll(".mask-box");
  images.forEach(imgDom => {
    removeMaskEvents(imgDom);
  });
});
</script>

<style scoped lang="less">
@import "components/ThemeTag/fontSize";
.container-box {
  display: flex;
  flex-direction: column;
  gap: 0.64rem;
  .card {
    position: relative;
    border-radius: 0.64rem;
    background: var(--card-bg-color);
    padding: 1.27rem 0.95rem;
    .num-tag {
      line-height: 1.3;
      padding: 0.2rem 0.4rem;
      border-radius: 0 0.4rem 0 0.64rem;
      font-size: 0.76rem;
      color: var(--card-num-text);
      background: var(--card-num-bg);
      position: absolute;
      right: 0;
      top: 0;
      z-index: 1;
      img {
        width: 0.76rem;
        height: 0.76rem;
        position: absolute;
      }
      .top {
        top: 0;
        left: -11px;
      }
      .bottom {
        right: 0;
        bottom: -11px;
      }
    }
    &_content {
      position: relative;
      .icon-translate {
        width: 1.28rem;
        height: 1.28rem;
        position: absolute;
        top: 0.2rem;
        left: 0.2rem;
      }
      .mask-box {
        width: 100%;
        height: 5rem;
        background-image: url("@/assets/listening/text-mask.png");
        background-size: contain;
        background-repeat: no-repeat;
      }
      .sentence {
        text-indent: 1.8em;
        color:var(--text-color);
        font-size: var(--step2-card-text);
      }

      .translate-text {
        color: #898c90;
        font-size: var(--step2-translate-text);
        margin: 0.5rem 0 0 0;
      }
    }

    .thumbnail-box {
      display: flex;
      flex-direction: column;
      gap: 0.7rem;
      .thumbnail-item {
        height: 1.2rem;
        border-radius: 0.14rem;
        background-color: var(--card-thumbnail-bg);
        &_1 {
          width: 80%;
        }
        &_2 {
          width: 40%;
        }
      }
    }
  }
  .card-active {
    border: 2px solid var(--card-border-color);
    background:var(--card-bg-active-color);;
    .num-tag {
      color: #ffffff;
      background: var(--card-border-color);
    }
  }
  .card-gray {
    border: 2px solid var(--card-gray-border-color);
    background: var(--card-gray-bg)
  }
}
.record-box{
  background-color: transparent;
}
</style>